import { Box, Typography } from '@mui/material';
import { referralDataColumns } from '../table/DashboardData';
import { Tables } from '@/component/pools/table/Tables';
import { ResReadReferralDataType } from '@/types';
import { packBigNumbers } from '@/lib/BigNumbers';

export default function ReferralData({ datas }: { datas: ResReadReferralDataType }) {
  const list: ResReadReferralDataType[] = [
    {
      id: '1',
      referral_bet_amount: packBigNumbers(datas.referral_bet_amount),
      referral_bet_count: packBigNumbers(datas.referral_bet_count),
      referral_win_amount: packBigNumbers(datas.referral_win_amount),
      referral_win_count: packBigNumbers(datas.referral_win_count),
      referral_small_win_amount: packBigNumbers(datas.referral_small_win_amount),
      referral_small_win_count: packBigNumbers(datas.referral_small_win_count),
      total_amount: packBigNumbers(datas.total_amount),
      total_count: packBigNumbers(datas.total_count),
    },
  ];

  return (
    <Box sx={{ mb: 3, px: 2, width: '100%' }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        레퍼럴 통계
      </Typography>

      <Box sx={{ width: '100%' }}>{list && <Tables list={list} columns={referralDataColumns} getRowId={(row) => row.id} />}</Box>
    </Box>
  );
}
